"use strict";

exports.__esModule = true;
exports.validateCustomTags = validateCustomTags;

var _identify = require("../../renderer/utils/identify");

var _parse = require("../../renderer/utils/parse");

var _Errors = require("../../types/Errors");

var _Validators = require("../../types/Validators");

function validateCustomTags(htmlString) {
  if (htmlString === '') {
    return {
      isValid: true
    };
  }

  var errors = [];
  var tags = (0, _parse.parse)(htmlString);

  if (!tags.length || !(0, _Validators.validateBrokenTags)(htmlString).isValid) {
    errors.push(new _Errors.ERRORS.INVALID_TAG_STRUCTURE());
  }

  var invalidAttributes = [];
  tags.forEach(function (tag) {
    var validationResult = (0, _Validators.validateIsInWhiteList)(tag);

    if (!validationResult.isValid) {
      errors.push(validationResult.error);
    }

    var attrValidationResult = (0, _Validators.validateAttributeIsInBlacklist)(tag);

    if (!attrValidationResult.isValid) {
      invalidAttributes = invalidAttributes.concat(attrValidationResult.error.duplicates);
    }
  });

  if (invalidAttributes.length) {
    errors.push(new _Errors.ERRORS.TAG_CONTAINS_BLACKLISTED_ATTRIBUTE(invalidAttributes));
  }

  var identifiedTags = getIdentifiedTags(tags);

  if (identifiedTags.length) {
    var types = identifiedTags.map(function (tag) {
      return tag.props && (tag.props.property || tag.props.content || tag.props.href);
    }).filter(function (prop) {
      return prop;
    });

    if (types.length) {
      errors.push(new _Errors.ERRORS.TAG_ALREADY_EXISTS(types));
    }
  }

  if (errors.length) {
    return {
      isValid: false,
      errors: errors
    };
  }

  return {
    isValid: true
  };
}

function getIdentifiedTags(tags) {
  return tags.filter(function (tag) {
    return (0, _identify.identify)(tag);
  });
}